"use client";

import Image from "next/image";

import { TimePeriod } from "@/components/app/discover-sort-constants";
import UserSearch from "@/components/shared/users-search/user-search";

import { WidgetPreset } from "../app-layout/sidebar-top-resutls-widget/sidebar-top-results-widget";
import { TopEarnersWidgetView } from "../app-layout/sidebar-top-resutls-widget/top-earners-widget-view";
import { ServerPageListener } from "../wallet/server-page-listener";

export const SearchEarnings = () => {
  return (
    <ServerPageListener>
      <div
        className="
          mx-auto flex max-w-[600px] flex-col items-center p-6
          sm:min-h-screen sm:justify-center
        "
      >
        <Image
          src="/assets/empty-36.png"
          alt="Wallet Search Illustration"
          width={100}
          height={0}
          className="mb-6"
        />
        <h2
          className="
            mb-2 text-center font-sans text-2xl font-semibold
            text-muted-foreground
          "
        >
          Search Earnings
        </h2>
        <p
          className="
          mx-auto mb-4 text-center text-sm/6 text-balance text-muted
        "
        >
          On Focus, everyone can monetize from day one. Creators have detailed
          earnings reports to see how their earnings accrue.
        </p>
        <div className="mb-6 flex w-full justify-center">
          <UserSearch
            placeholder="Search users..."
            baseRedirectUrl="/earnings/"
          />
        </div>

        <div className="w-full rounded-2xl border">
          <TopEarnersWidgetView
            preset={WidgetPreset.topEarners}
            selectedTimePeriod={TimePeriod.AllTime}
            baseRedirectUrl="/earnings/"
          />
        </div>
      </div>
    </ServerPageListener>
  );
};
